<template>
  <div
    class="d-flex-column justify-start align-start wow_raid_schedule b-radius-9"
    :class="[
      checkoutStore.getSelectedRaid?.id === id && 'active',
      difficulty,
      isSelected && 'active',
    ]"
  >
    <p class="bold-l font-family-2 t-white">{{ title }}</p>
    <!-- <img
            :src="`/images/games/world-of-warcraft-boost/difficulties/${difficulty.toLowerCase()}-faded.webp`"
            alt="difficulty_image"
            class="difficulty_image"
            width="100"
            height="50"
        /> -->
    <div class="d-flex-row justify-start sm-row-to-col">
      <div class="d-flex-column justify-start align-start gap-5 flex-3">
        <label class="regular-s t-grey font-family-2" v-if="server === 1">{{
          $t("new.checkout.time_cet")
        }}</label>
        <label
          class="regular-s t-grey font-family-2"
          v-else-if="server === 2"
          >{{ $t("new.checkout.time_us") }}</label
        >
        <p class="t-green font-family-2 medium-m">{{ date }}</p>
      </div>
      <div
        class="d-flex-column justify-start align-start gap-5 flex-3"
        v-if="loot"
      >
        <label class="regular-s t-grey font-family-2">{{
          $t("new.checkout.loot")
        }}</label>
        <p
          class="t-white font-family-2 medium-m"
          :class="[loot === 'Vip Loot' && 't-light-blue']"
        >
          {{ loot }}
        </p>
      </div>
      <div class="d-flex-column justify-start align-start gap-5 flex-3">
        <label class="regular-s t-grey font-family-2">{{
          $t("new.checkout.difficulty")
        }}</label>
        <p class="t-white font-family-2 medium-m">{{ difficulty }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    title: {
      default: "",
    },
    difficulty: {
      default: "",
    },
    loot: {
      default: "",
    },
    date: {
      default: null,
    },
    id: {
      default: "",
    },
    isSelected: {
      default: false,
    },
    server: {
      default: 1,
    },
  },
  computed: {
    cetTime() {
      if (this.date) {
        const inputDateTime = new Date(this.date);

        return inputDateTime.toLocaleString("en-US", {
          timeZone: "CET",
          hour12: false,
          hour: "2-digit",
          minute: "2-digit",
        });
      }
      return "";
    },
  },
  setup() {
    const checkoutStore = useCheckoutStore();
    return {
      checkoutStore,
    };
  },
};
</script>
